export default __webpack_public_path__ + "a36dc9a8425ffadbc74315b9a9daeea2.png";